import * as React from "react";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ValueType } from "../../../../../../../core/models/enums/core.enums";
import DynamicForm from "../../../../../../../core/presentations/DynamicForm";
import Validators from "../../../../../../../ui/helpers/validators";
import { OptionsConstants } from "../../../../../../../ui/models/constants/options.constants";
import VerticalInputTextArrayTemplate from "../../../../../../../ui/templates/arrays/VerticalInputTextArrayTemplate";
import RightLabelFieldTemplate from "../../../../../../../ui/templates/fields/RightLabelFieldTemplate";
import TopLabelFieldTemplate from "../../../../../../../ui/templates/fields/TopLabelFieldTemplate";
import VerticalFormTemplate from "../../../../../../../ui/templates/objects/VerticalFormTemplate";
import PrwcBasicButton from "../../../../../../../ui/widgets/custom/buttons/PrwcBasicButton";

const Attribute = (props: any) => {
  const { data } = props;
  const { t } = useTranslation();
  const submitButtonRef: any = useRef(null);
  const [formData, setFormData] = useState(data ?? undefined);

  const onSubmit = (data: any) => {
    console.log("data submitted ---");
    console.log(data);
  };

  const onError = (data: any) => {
    console.log("on error ---");
    console.log(data);
  };

  const onChange = (formData: any) => {
    setFormData(formData);
  };

  const handleOnSubmit = () => {
    // It is to submit form programmatically.
    submitButtonRef.current.click();
  };

  const formButtons = () => {
    return (
      <button ref={submitButtonRef} type="submit" className="hidden p-col-12" />
    );
  };

  // const processFormData = () => {
  //   // TODO: Set the valueRange to [] if valueType is other than 'TEXT'.
  // }

  let schema: any = {
    title: t("userCategories.label.general"),
    type: "object",
    properties: {
      attributeName: {
        type: "string",
        title: t("userCategories.label.attributeName"),
      },
      abbreviation: {
        type: "string",
        title: t("userCategories.label.abbreviation"),
      },
      description: {
        type: "string",
        title: t("userCategories.label.description"),
      },
      valueType: {
        type: "string",
        title: t("userCategories.label.valueType"),
        default:  ValueType.TEXT
      },
    },
    required: ["attributeName"],
    dependencies: {
      valueType: {
        oneOf: [
          {
            properties: {
              valueType: {
                const: ValueType.TEXT,
              },
              fixedValueRange: {
                type: "boolean",
                title: t("userCategories.label.fixedValueRange"),
              },
            },
          },
          {
            properties: {
              valueType: {
                enum: [
                  ValueType.DATE,
                  ValueType.YES_NO,
                  ValueType.WHOLE_NUMBER,
                  ValueType.DECIMAL_NUMBER,
                  ValueType.PHONE,
                  ValueType.EMAIL,
                ],
              },
            },
          },
        ],
      },
      fixedValueRange: {
        oneOf: [
          {
            properties: {
              fixedValueRange: {
                type: "boolean",
                title: t("userCategories.label.fixedValueRange"),
                const: true
              },
              valueRange: {
                type: "array",
                title: t("userCategories.label.valueRange"),
                minItems: 1,
                items: {
                  type: "string",
                },
              }
            },
          },
          {
            properties: {
              fixedValueRange: {
                type: "boolean",
                title: t("userCategories.label.fixedValueRange"),
                const: false
              }
            },
          },
        ],
      },
    },
  };

  const validationSchema: any = {
    attributeName: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey:
            "userCategories.validation.attribute.attributeNameRequired",
        },
        {
          validate: (value: string) => {
            return Validators.isMaxLengthValid(value, 15);
          },
          messageKey:
            "userCategories.validation.attribute.attributeNameMaxLength",
        },
      ],
    },
    abbreviation: {
      validators: [
        {
          validate: (value: string) => {
            return Validators.isMaxLengthValid(value, 15);
          },
          messageKey:
            "userCategories.validation.attribute.abbreviationMaxLength",
        },
      ],
    },
    description: {
      validators: [
        {
          validate: (value: string) => {
            return Validators.isMaxLengthValid(value, 100);
          },
          messageKey:
            "userCategories.validation.attribute.descriptionMaxLength",
        },
      ],
    },
  };

  let uiSchema: any = {
    "ui:ObjectFieldTemplate": VerticalFormTemplate,
    attributeName: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    abbreviation: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    description: {
      "ui:widget": "prwInputTextArea",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    valueType: {
      "ui:widget": "prwDropdownBasic",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:options": {
        dropdownOptions: OptionsConstants.ValueTypes,
      },
    },
    fixedValueRange: {
      "ui:widget": "prwCheckbox",
      "ui:FieldTemplate": RightLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    valueRange: {
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
      "ui:ArrayFieldTemplate": VerticalInputTextArrayTemplate,
      "ui:options": {
        addable: true,
        removable: true,
      },
      items: {
        "ui:widget": "prwInputText",
      },
    },
  };

  return (
    <div className="group">
      <div className="px-4 overflow-y-auto content-height">
        <DynamicForm
          onChange={onChange}
          formData={formData}
          onSubmit={onSubmit}
          onError={onError}
          schema={schema}
          uiSchema={uiSchema}
          validationSchema={validationSchema}
          formButtons={() => formButtons()}
        ></DynamicForm>
      </div>
      <div className="flex justify-end px-2 border-t">
        <PrwcBasicButton
          onClick={handleOnSubmit}
          labelKey="users.action.save"
          className="w-24 h-8 my-1 bg-blue-700 border-blue-700 p-button-sm"
        ></PrwcBasicButton>
      </div>
    </div>
  );
};

export default Attribute;
